import { scaleLinear, scaleUtc } from '@visx/scale';
import { useRef } from 'react';

import { CountryISO } from '@/constants/countries';

import {
  CHART_PADDING,
  CHART_PADDING_BOTTOM,
  CHART_PADDING_RIGHT,
} from './constants';

import { Metrics } from '../Metrics';
import { XAxis } from '../XAxis';
import { YAxis } from '../YAxis';

import type { PerformancePeriod } from '../../types';

import { ChartWrapper, StyledSVG } from './styled';

interface Props {
  width: number;
  height: number;
  market: CountryISO;
  period: PerformancePeriod;
  endTimestamp: number;
  startTimestamp: number;
}

export const RestrictedChart = ({
  width,
  height,
  market,
  period,
  endTimestamp,
  startTimestamp,
}: Props) => {
  const { current: xScale } = useRef(scaleUtc<number>());
  const { current: yScale } = useRef(scaleLinear<number>());

  xScale.range([CHART_PADDING, width - CHART_PADDING_RIGHT]);
  xScale.domain([startTimestamp, endTimestamp]);

  yScale.range([height - CHART_PADDING_BOTTOM, CHART_PADDING]);
  yScale.domain([0, 0]);

  return (
    <>
      <Metrics
        market={market}
        marketMetric={null}
        portfolioMetric={null}
        portfolioTrend="neutral"
      />
      <ChartWrapper>
        <StyledSVG
          y="0"
          x="0"
          width={width}
          height={height}
          role="application"
          aria-label="Portfolio Performance Chart"
        >
          <XAxis xScale={xScale} yScale={yScale} period={period} />
          <YAxis yScale={yScale} width={width} />
        </StyledSVG>
      </ChartWrapper>
    </>
  );
};
